import { GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { TableTooltip } from '../../../../components/general/table';
import { DateTooltip } from '../../../../components/general/dateTooltip';
import { SurveyLogsProps, fieldEquivalences, typeLabels } from './props';

export const useSurveyLogs = ({ historical }: SurveyLogsProps) => {
    const getTypeColor = (type: string) => {
        switch (type) {
            case 'survey':
                return 'primary';
            case 'question':
                return 'secondary';
            case 'answer':
                return 'success';
            default:
                return 'default';
        }
    };

    const columns: GridColDef[] = [
        {
            field: 'type',
            headerName: 'Tipo',
            minWidth: 100,
            flex: 0.2,
            renderCell: (params) => (
                <Chip
                    label={typeLabels[params.row.type] || params.row.type}
                    color={getTypeColor(params.row.type) as any}
                    size="small"
                />
            ),
        },
        {
            field: 'fieldChange',
            headerName: 'Campo Modificado',
            minWidth: 150,
            flex: 0.3,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.elementos.field
                            ? fieldEquivalences[params.row.elementos.field] ||
                              params.row.elementos.field
                            : ''
                    }
                />
            ),
        },
        {
            field: 'oldValue',
            headerName: 'Valor Anterior',
            minWidth: 150,
            flex: 0.3,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.elementos.oldValue !== undefined &&
                        params.row.elementos.oldValue !== null
                            ? `${params.row.elementos.oldValue}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'newValue',
            headerName: 'Valor Nuevo',
            minWidth: 150,
            flex: 0.3,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.elementos.newValue !== undefined &&
                        params.row.elementos.newValue !== null
                            ? `${params.row.elementos.newValue}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de modificación',
            minWidth: 120,
            flex: 0.25,
            renderCell: (params) => (
                <DateTooltip date={params.row.created_at} showFornow />
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Usuario',
            minWidth: 150,
            flex: 0.3,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.createdBy
                            ? `(${params.row.createdBy.username}) ${params.row.createdBy.name} ${params.row.createdBy.surname}`
                            : ''
                    }
                />
            ),
        },
    ];

    const rows =
        historical?.flatMap((row) => {
            if (row.changes) {
                const { changes, created_at, createdBy, type } = row;

                // Convertir el objeto changes a array si es necesario
                const changesArray = Array.isArray(changes)
                    ? changes
                    : Object.entries(changes).map(
                        ([field, change]: [string, any]) => ({
                            field,
                            oldValue: change.from,
                            newValue: change.to,
                        })
                    );

                return changesArray.map((elemento, index) => {
                    const newValue =
                        elemento.newValue === false
                            ? 'false'
                            : elemento.newValue !== null &&
                              elemento.newValue !== undefined
                                ? elemento.newValue
                                : '';

                    const oldValue =
                        elemento.oldValue === false
                            ? 'false'
                            : elemento.oldValue !== null &&
                              elemento.oldValue !== undefined
                                ? elemento.oldValue
                                : '(Creación)';

                    return {
                        ...row,
                        type,
                        elementos: {
                            field: elemento.field,
                            newValue,
                            oldValue,
                        },
                        id: row.id + '-' + index,
                        created_at,
                        createdBy,
                    };
                });
            }
            return [];
        }) || [];

    return {
        columns,
        rows,
    };
};
